import React from 'react';
import { useProofOfAddressVerificationContext } from '../../../../../../contexts/proof-of-address-verification/ProofOfAddressVerificationContext';
import AccountVerificationDocumentUpload from '../../../document/upload/AccountVerificationDocumentUpload';

export default function AccountVerificationProofOfAddressSteps4() {
    const { reset, documentUpload } = useProofOfAddressVerificationContext();

    return <AccountVerificationDocumentUpload documentUpload={documentUpload} onResetButtonClick={reset} />;
}
